/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Is this order a buy or sell?
 */
export enum OrderKind {
    BUY = 'buy',
    SELL = 'sell',
}
